import { render, staticRenderFns } from "./commonImg.vue?vue&type=template&id=21767f88&"
import script from "./commonImg.vue?vue&type=script&lang=js&"
export * from "./commonImg.vue?vue&type=script&lang=js&"
import style0 from "./commonImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports